function title() {
  return(
  `
    <div class="santa-game-container">
      <p class="santa-game-container_main-title">Santa</p>
      <p class="santa-game-container_secondary-title">Game</p>
    </div>
  `
  )
}

export default title;